module.exports = __webpack_public_path__ + "static/media/go_arrow.69052a33.svg";